// Custom dayjs locale for Irish Gaelic (Gaeilge)
export const ga = {
    name: 'ga',
    weekdays: [
        'Dé Domhnaigh',
        'Dé Luain',
        'Dé Máirt',
        'Dé Céadaoin',
        'Déardaoin',
        'Dé hAoine',
        'Dé Sathairn',
    ],
    weekdaysShort: ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'],
    weekdaysMin: ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'hA', 'Sa'],
    months: [
        'Eanáir',
        'Feabhra',
        'Márta',
        'Aibreán',
        'Bealtaine',
        'Meitheamh',
        'Iúil',
        'Lúnasa',
        'Meán Fómhair',
        'Deireadh Fómhair',
        'Samhain',
        'Nollaig',
    ],
    monthsShort: [
        'Ean',
        'Fea',
        'Már',
        'Aib',
        'Bea',
        'Mei',
        'Iúi',
        'Lún',
        'Meá',
        'Dei',
        'Sam',
        'Nol',
    ],
    weekStart: 1, // Monday
    yearStart: 4,
    formats: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMM YYYY',
        LLL: 'D MMM YYYY HH:mm',
        LLLL: 'dddd, D MMM YYYY HH:mm',
    },
    relativeTime: {
        future: 'i %s',
        past: '%s ó shin',
        s: 'cúpla soicind',
        m: 'nóiméad',
        mm: '%d nóiméad',
        h: 'uair',
        hh: '%d uair',
        d: 'lá',
        dd: '%d lá',
        M: 'mí',
        MM: '%d mí',
        y: 'bliain',
        yy: '%d bliain',
    },
    ordinal: (n: number) => n + (n === 1 ? 'ú' : n === 2 ? 'ú' : n === 3 ? 'ú' : 'ú'),
};
